import React, {useState} from "react";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [menuIcon, setMenuIcon] = useState(false);
    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setMenuIcon(!menuIcon);
    };

    return (
        <div className="header-container">
            <div className="header-content">
                <div className="header-menu">
                    <a href="/" className="logo" alt="logo"><img className="logo2" src="/images/logobc.svg"/></a> 
                    <div>
                    <a className="menu-title" href="/">Início</a>
                    <a className="menu-title" href="/produtos">Produtos</a>
                    <a className="menu-title" href="/assistencia-tecnica">Assistência Técnica</a>
                    <a className="menu-title" href="/comercial">Comercial</a>
                    <a className="menu-title" href="/balancas-cuiaba">Balanças Cuiabá</a>
                    {/* <a className="btn-header" onClick={navArea}>Área do Cliente</a> */}
                    </div>
                </div>
                {menuIcon ?
                 <><CloseRoundedIcon onClick={toggleMenu} sx={{display:(isOpen ? '' : 'none'), color:'#FFF', fontSize:36, marginLeft:1.2, cursor:"pointer"}}/></>: 
                 <div className="hamburger-icon" onClick={toggleMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
                }
            </div>
            <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
                <a className="menu-title" href="/">Início</a>
                <a className="menu-title" href="/produtos">Produtos</a>
                <a className="menu-title" href="/assistencia-tecnica">Assistência Técnica</a>
                <a className="menu-title" href="/comercial">Comercial</a>
                <a className="menu-title" href="/balancas-cuiaba">Balanças Cuiabá</a>
                {/* <a className="btn-header" onClick={navArea}>Área do Cliente</a> */}
            </div>
        </div>
    )
}
export default Header;